import type { IReportStoragePort } from '@reports/application/ports';
import type { FiltersMetadata } from '@reports/infrastructure/repositories/types';

/**
 * Use case to get filters metadata from storage
 *
 * @param storagePort - Storage port implementation
 * @returns Use case with execute method
 */
export const getFiltersMetadataUseCase = (storagePort: IReportStoragePort) => {
  const execute = async (): Promise<FiltersMetadata | null> => {
    const metadata = await storagePort.getFiltersMetadata();

    return metadata;
  };

  return { execute };
};
